import React, { useState } from 'react';
import moment from 'moment';

import { useBeneficiarioEventual } from '../../contexts/BeneficiarioEventual/context';
import { useGlobal } from '../../contexts/Global/context';
import Accordion from '../Accordion';
import Modal from '../Modal';
import Icon from '../Icons';

import * as S from './styles';

function ConfirmQueryData(props) {
    const { dataBeneficiario } = props;
    const { contrastTheme } = useGlobal();
    const [showModal, setShowModal] = useState(false);
    const { dataEspecialidade } = useBeneficiarioEventual();

    function handleMaps() {
        if (dataBeneficiario?.estabelecimento) {
            if (dataBeneficiario?.estabelecimento?.latitude && dataBeneficiario?.estabelecimento?.longitude) {
                const latitude = dataBeneficiario?.estabelecimento?.latitude.replace(',', '.');
                const longitude = dataBeneficiario?.estabelecimento?.longitude.replace(',', '.');

                window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank');
            }

            return false;
        }

        return true;
    }

    return (
        <>
            <S.Container>
                <div style={{ width: ' 100%' }}>
                    <Accordion title={dataBeneficiario?.estabelecimento?.nome} hasCollapse={false}>
                        <S.DivInfo>
                            <p>
                                {dataBeneficiario?.estabelecimento?.endereco?.bairro || '-'} -{' '}
                                {dataBeneficiario?.estabelecimento?.endereco?.cidade || '-'} -{' '}
                                {dataBeneficiario?.estabelecimento?.endereco?.estado || '-'} -{' '}
                                {dataBeneficiario?.estabelecimento?.endereco?.logradouro || '-'}
                            </p>
                            <S.ButtonHospitalArea>
                                <S.ButtonMap>
                                    <S.IconPosition>
                                        <Icon name="location_on" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />{' '}
                                    </S.IconPosition>
                                    <strong onClick={() => handleMaps()}>Ver mapa</strong>
                                </S.ButtonMap>
                                <S.ButtonInfo>
                                    <S.IconPosition onClick={() => setShowModal(true)}>
                                        <Icon name="info" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                    </S.IconPosition>
                                    <strong onClick={() => setShowModal(true)}>Informação</strong>
                                </S.ButtonInfo>
                            </S.ButtonHospitalArea>
                        </S.DivInfo>
                        <S.DivSpecialty>
                            <p>Especialidade agendada</p>
                            <p className="textSpan">{dataEspecialidade?.lookup || '-'}</p>
                        </S.DivSpecialty>
                        <S.DivEndItem>
                            <div>
                                <p>{dataBeneficiario?.medico?.nome || '-'}</p>
                            </div>
                            <div>
                                <p className="hours">
                                    {moment(dataBeneficiario?.data).format('DD/MM/YYYY - HH:mm') || '-'}
                                </p>
                            </div>
                        </S.DivEndItem>
                    </Accordion>
                </div>
            </S.Container>
            <Modal
                title={dataBeneficiario?.estabelecimento?.nome}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <S.styledDivModal>
                    <div>
                        <span>Endereço</span>
                        <p>
                            {dataBeneficiario?.estabelecimento?.endereco?.bairro || '-'} -{' '}
                            {dataBeneficiario?.estabelecimento?.endereco?.cidade || '-'} -{' '}
                            {dataBeneficiario?.estabelecimento?.endereco?.estado || '-'}
                        </p>
                    </div>
                    <div>
                        <span>Atendimento</span>
                        <p>{dataBeneficiario?.estabelecimento?.endereco?.logradouro || '-'}</p>
                    </div>
                </S.styledDivModal>
            </Modal>
        </>
    );
}
export default ConfirmQueryData;
